import { cn } from '~/utils/cn'

type Props = {
  title: string
  description?: string | React.ReactNode
  children: React.ReactNode
  className?: string
}

export function SubSection(props: Props) {
  return (
    <div className={cn('grid grid-cols-1 gap-4 py-5 md:py-2 lg:grid-cols-[1fr_1fr] lg:gap-6 lg:py-4', props.className)}>
      <div className="flex flex-col gap-2">
        <h4 className="text-sm font-semibold">{props.title}</h4>
        <p className="text-sm text-muted-foreground">{props.description}</p>
      </div>
      {props.children}
    </div>
  )
}
